import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EditorConfig } from '@fleet-beat/editor';
import { FormDialogOptions } from '@fleet-beat/shared';
import { finalize } from 'rxjs';

@Component({
  selector: 'fb-form-dialog',
  templateUrl: './form-dialog-container.component.html',
  styleUrls: ['./form-dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDialogContainerComponent {
  options: FormDialogOptions;
  form: FormGroup;
  config: EditorConfig;
  submitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: FormDialogOptions,
    private dialogRef: MatDialogRef<FormDialogContainerComponent>,
    private cdr: ChangeDetectorRef,
  ) {
    this.options = data;
    this.form = data.form;
    this.config = data.config;
  }
  onClose(): void {
    if (this.submitting) {
      return;
    }

    this.dialogRef.close(this.options?.closeAction);
  }

  onSubmit(): void {
    if (this.form.invalid || this.submitting) {
      return;
    }
    const formValue = this.form?.getRawValue?.() ?? this.form?.value;
    const submit = this.options?.submit;

    if (!submit) {
      this.dialogRef.close(formValue);
      return;
    }
    this.submitting = true;
    this.cdr.markForCheck();

    submit(formValue)
      .pipe(
        finalize(() => {
          this.submitting = false;
          this.cdr.markForCheck();
        }),
      )
      .subscribe({
        next: (result) => {
          this.dialogRef.close(result ?? true);
        },
      });
  }
}
